module.exports = __webpack_public_path__ + "static/media/ic_编辑.a3e8a3f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_编辑.svg
// module id = 101
// module chunks = 0